// This file is automatically generated. Do not edit manually.

import { IsoDateString } from "src/types/dateTime";
import { PurchaseRequest } from "src/api/generated/erp/db/types/tables/purchaseRequest";
import { PurchaseRequestView } from "src/api/generated/erp/db/types/tables/purchaseRequestView";
import { SupplierPartView } from "src/api/generated/erp/db/types/tables/supplierPartView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseRequestFormApi {
	export async function getInitialData(args: {
		purchaseRequestId: number | null | undefined;
	}): Promise<PurchaseRequestFormApi_InitialData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseRequests/form/getInitialData",
			method: "POST",
			data: {
				purchaseRequestId: args.purchaseRequestId,
			},
		});
		return response as PurchaseRequestFormApi_InitialData;
	}

	export async function insert(args: {
		supplierPartId: number;
		quantity: number;
		demandDate: IsoDateString;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseRequests/form/insert",
			method: "POST",
			data: {
				supplierPartId: args.supplierPartId,
				quantity: args.quantity,
				demandDate: args.demandDate,
			},
		});
		return response as number;
	}

	export async function update(args: { purchaseRequest: PurchaseRequest }): Promise<PurchaseRequest> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseRequests/form/update",
			method: "POST",
			data: {
				purchaseRequest: args.purchaseRequest,
			},
		});
		return response as PurchaseRequest;
	}
}

export interface PurchaseRequestFormApi_InitialData {
	purchaseRequest: PurchaseRequestView | null | undefined;
	supplierPartIdOptions: Array<SupplierPartView>;
}
